// ═══════════════════════════════════════════════════════════════════════════
//  PERBARUI OTOMATIS LAYAR TV (27 Okt 2026)
//
//  Zaldy: "kenapa balik lagi muncul Lirik pas / Sembunyikan lirik di layar".
//  Kodenya sudah benar; TV kamar (Firefox kiosk) membiarkan halaman terbuka
//  berhari-hari, jadi versi baru hasil deploy tidak pernah termuat sampai ada
//  yang menekan F5. Sekarang: tiap 5 menit layar membandingkan skrip utama di
//  /index.html (tanpa cache) dengan skrip yang sedang jalan. Ada versi baru →
//  halaman dimuat ulang SAAT ROOM DIAM (tidak ada lagu diputar/menunggu),
//  jadi lagu tamu tidak pernah terputus.
// ═══════════════════════════════════════════════════════════════════════════
import { useEffect, useRef } from 'react'

function skripSekarang(): string {
  const s = document.querySelector('script[type="module"][src*="/assets/"]') as HTMLScriptElement | null
  return s ? new URL(s.src, location.href).pathname : ''
}

export async function adaVersiBaru(): Promise<boolean> {
  const kini = skripSekarang()
  if (!kini) return false // mode pengembangan (vite dev) — tidak ada aset ber-hash
  const r = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' })
  if (!r.ok) return false
  const t = await r.text()
  const m = t.match(/<script[^>]*type="module"[^>]*src="([^"]+)"/)
  if (!m) return false
  return new URL(m[1], location.href).pathname !== kini
}

/** `diam` = room tidak sedang memutar / tidak ada antrean — aman dimuat ulang. */
export function usePerbaruiOtomatis(diam: boolean) {
  const diamRef = useRef(diam)
  diamRef.current = diam
  const baruRef = useRef(false)
  useEffect(() => {
    let hidup = true
    const cek = async () => {
      try {
        if (!baruRef.current && await adaVersiBaru()) baruRef.current = true
      } catch { /* jaringan putus — coba lagi nanti */ }
      if (hidup && baruRef.current && diamRef.current) location.reload()
    }
    const awal = window.setTimeout(cek, 60_000)
    const iv = window.setInterval(cek, 5 * 60_000)
    return () => { hidup = false; window.clearTimeout(awal); window.clearInterval(iv) }
  }, [])
  useEffect(() => { if (diam && baruRef.current) location.reload() }, [diam])
}
